import { createAction } from 'redux-actions';
import getGuid from 'ui-forms-editor-automation-lib/selectors/getGuid';
import getWebsiteFlows from 'ui-forms-editor-automation-lib/api/getWebsiteFlows';
import createErrorAction from 'ui-forms-editor-automation-lib/utils/createErrorAction';
import getApplicationName from 'ui-forms-editor-automation-lib/selectors/parentApplication/getApplicationName';
import APPLICATION_NAMES from 'ui-forms-editor-automation-lib/constants/APPLICATION_NAMES';
import getWebsiteFlowsFetchRequestState from 'ui-forms-editor-automation-lib/selectors/websiteFlows/getWebsiteFlowsFetchRequestState';
import getWebsiteFlowsGuid from 'ui-forms-editor-automation-lib/selectors/websiteFlows/getWebsiteFlowsGuid';
export const REQUEST_WEBSITE_FLOWS = '@@lib/REQUEST_WEBSITE_FLOWS';
export const RECEIVE_WEBSITE_FLOWS = '@@lib/RECEIVE_WEBSITE_FLOWS';
export const FAIL_GETTING_WEBSITE_FLOWS = '@@lib/FAIL_GETTING_WEBSITE_FLOWS';
export const requestWebsiteFlows = createAction(REQUEST_WEBSITE_FLOWS);
export const receiveWebsiteFlows = createAction(RECEIVE_WEBSITE_FLOWS);
export const failGettingWebsiteFlows = createErrorAction(FAIL_GETTING_WEBSITE_FLOWS, 'automationLib.errorMessages.failReceivingWebsiteWorkflows');
const fetchWebsiteFlows = providedGuid => (dispatch, getState) => {
  const state = getState();
  const guid = providedGuid || getGuid(state);
  if (!getWebsiteFlowsFetchRequestState(state).shouldBeRequested() && getWebsiteFlowsGuid(state) === guid) {
    return Promise.resolve();
  }
  const applicationName = getApplicationName(state);
  dispatch(requestWebsiteFlows(guid));
  switch (applicationName) {
    case APPLICATION_NAMES.LEADFLOWSUI:
      return dispatch(receiveWebsiteFlows([]));
    case APPLICATION_NAMES.FORMSUI:
    default:
      return getWebsiteFlows(guid).then(websiteFlows => {
        dispatch(receiveWebsiteFlows(websiteFlows));
      }).catch(error => {
        dispatch(failGettingWebsiteFlows(error));
      });
  }
};
export default fetchWebsiteFlows;